import classNames from "classnames";
import { PlayerPublic } from "../../models/Player";
import store from "../../store/store";
import { getWinrateString } from "../../utils/formatting";

export default function Stats(props: {
  player: Partial<PlayerPublic> | null,
  classes?: string[] | string | null;
  closeButton: React.ReactNode;
}) {
  const { player, classes, closeButton } = props;
  const gameState = store.getState().game;

  const statsClasses = classNames({
    'player_stats': true,
    'game_tooltip': true,
    'player_stats_tooltip': true,
  }, classes);

  const storytellingTurns = gameState.gameId
    ? player?.sentences?.length || 0
    : null;

  const notStorytellingTurns = storytellingTurns && gameState.gameId
    ? gameState.turnNumber - storytellingTurns
    : null;

  return (
    <div className={statsClasses}>
      {closeButton && closeButton}
      {player && <>
        <ul className="player_stats_tooltip_list">
          <li className="li-block">{player.username}</li>
          <li>Place: <span className="value">{player.place || '-'}</span></li>
          <li>Guesses: <span className="value">{player?.guessCount || 0}{notStorytellingTurns ? '/' + notStorytellingTurns : ''} {notStorytellingTurns ? `(${getWinrateString(notStorytellingTurns, player?.guessCount)})` : ''}</span></li>
          <li>Matches: <span className="value">{player?.matchCount || 0}{notStorytellingTurns ? '/' + notStorytellingTurns : ''} {notStorytellingTurns ? `(${getWinrateString(notStorytellingTurns, player?.matchCount)})` : ''}</span></li>
          <li>Waiting For: <span className="value">{player.waitingForCount || 0}</span></li>
          <li>Only Guesser count: <span className="value">{player.onlyGuesserCount || 0}</span></li>
          <li>Max score count: <span className="value">{player.maxScoreTurnCount || 0}</span></li>
          <li className="li-block">Score:</li>
          <li className="li-indent">- Pure guesses: <span className="value">{player.guessScore || 0}</span></li>
          <li className="li-indent">- Matches score: <span className="value">{player.matchCount || 0}</span></li>
          <li className="li-indent">- Storyteller's votes: <span className="value">{player.storytellerVoteCount || 0}</span></li>
          <li className="li-indent">- As storyteller: <span className="value">{player.storytellerScore || 0}</span></li>
          <li className="li-indent">- From failed storyteller: <span className="value">{player.failedStorytellerScore || 0}</span></li>
          <li className="li-block">Storyteller:</li>
          <li className="li-indent">- Successful: <span className="value">{player?.successfulStorytellCount || 0}{storytellingTurns ? '/' + storytellingTurns : ''} {notStorytellingTurns ? `(${getWinrateString(storytellingTurns, player.successfulStorytellCount)})` : ''}</span></li>
          <li className="li-indent">- Failed (All): <span className="value">{player?.failedStorytellerAllCount || 0}{storytellingTurns ? '/' + storytellingTurns : ''} {notStorytellingTurns ? `(${getWinrateString(storytellingTurns, player.failedStorytellerAllCount)})` : ''}</span></li>
          <li className="li-indent">- Failed (No One): <span className="value">{player?.failedStorytellerNoOneCount || 0}{storytellingTurns ? '/' + storytellingTurns : ''} {notStorytellingTurns ? `(${getWinrateString(storytellingTurns, player.failedStorytellerNoOneCount)})` : ''}</span></li>
          <li className="li-block"></li>
          {/* does not work properly */}
          {/* <li>Last seen: <span className="value small">{player.lastConnected ? new Date(player.lastConnected).toLocaleString() || '?' : 'just now'}</span></li> */}
        </ul>
      </>
      }
    </div>
  )
}